export default "__VITE_ASSET__15e63bfb__"